import '../gallery/GalleryPage.css';
import { db } from '../../../src/service/firebaseconfig';
import { collection, getDocs } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import LoaderSVG from "../Loader/LoaderSVG";


function Gallery() {
  const [Galeryimagedata, setGaleryimagedata] = useState([]);
  const [spinner, setSpinner] = useState(false)

  const GIdataRef = collection(db, "Gallery_Image");

  const getGalaryimageDetails = async () => {
    try {
      setSpinner(true)
      const Eventdoc = await getDocs(GIdataRef);
      const filteredData = Eventdoc.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      const imgArray = []
      filteredData.map(image => {
        image.GI.map(pic => {
          imgArray.push(pic)
        })
      })
      setGaleryimagedata(imgArray);
    } catch (err) {
      console.error(err);
    } finally {
      setSpinner(false)
    }
  };

  useEffect(() => {
    getGalaryimageDetails();
  }, []);

  return (
    <section>
      <>{spinner ? <LoaderSVG/> : (
        <>
          <div className="gallery web-view">
            {Galeryimagedata.map((picture, pictureIndex) => (
              <div className="gallery-item" key={pictureIndex}>
                <img
                  key={pictureIndex}
                  src={picture}
                  alt={`Gallery image ${pictureIndex + 1}`}
                  className="gallery-image"
                />
              </div>
            ))}
          </div>

          <div className="mobile-gallery mobile-view">
            {Galeryimagedata.map((picture, pictureIndex) => (
              <div className="gallery-item" key={pictureIndex}>
                <img
                  key={pictureIndex}
                  src={picture}
                  alt={`Gallery image ${pictureIndex + 1}`}
                  className="gallery-image"
                />
              </div>
            ))}
          </div>
        </>)}
      </>
    </section >
  );
}

export default Gallery;
